import { render, staticRenderFns } from "./playground-of-varosliget.vue?vue&type=template&id=58950722&scoped=true&"
import script from "./playground-of-varosliget.vue?vue&type=script&lang=js&"
export * from "./playground-of-varosliget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58950722",
  null
  
)

export default component.exports